import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export const videoInitialValues =  (subSection: SubSection) => ({
  videoId: subSection.mediaId || "",
  title: subSection?.title || "",
  src: subSection?.attrs?.src || "",
  caption: subSection?.attrs?.caption || "",
});

export const videoValidationSchema = Yup.object({
  src: Yup.string().required("Video is required"),
  caption: Yup.string().required("Caption is required"),
});
